import React, { Component, useContext, useEffect, useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { ThemeContext } from '../../../../context/theme-context';
import '../Summary.scss'
import * as ReactDOMServer from "react-dom/server";

const PricePerformance = (props) => { // props: {data,domId}
    const [chartData, setChartData] = useState([]);
    const [theme, setTheme] = useState('dark'); // ['dark', 'light'
    const currentTheme = useContext(ThemeContext).theme;
    const [chartDomId, setChartDomId] = useState("");

    useEffect(() => {
        setTheme(currentTheme);
    }, [currentTheme]);


    useEffect(() => {
        // root.dispose();
        setChartData(props.data);
        setChartDomId(props.domId);
        // console.log('PricePerformance useEffect' + props.domId);
    }, [props.domId, props.data, theme]);

    useLayoutEffect(() => {
        setChartDomId(props.domId);
        let root = am5.Root.new(props?.domId);
        root.setThemes([
            am5themes_Animated.new(root),

        ]);

        let chart = root.container.children.push(
            am5xy.XYChart.new(root, {
                panY: false,
                panX: false,
                layout: root.verticalLayout,
                minTooltipDistance: 10,
                paddingLeft: 0,
            })
        );


        // Create Y-axis
        var yAxis = chart.yAxes.push(
            am5xy.CategoryAxis.new(root, {
                categoryField: "Name",

                renderer: am5xy.AxisRendererY.new(root, {
                    inversed: true,
                    cellStartLocation: 0.1,
                    cellEndLocation: 0.9,
                    minGridDistance: 30,

                })
            })
        );

        yAxis.get("renderer").grid.template.setAll({
            strokeOpacity: 1,
            stroke: theme === 'dark' ? am5.color('#626262') : am5.color('#E4E4E4'),
            strokeDasharray: [4, 4],

        });

        yAxis.get("renderer").labels.template.setAll({
            oversizedBehavior: "wrap",
            maxWidth: 250,
            textAlign: "center",
            fontSize: 12,
            fontFamily: 'Roboto-Medium',
            fill: theme === 'dark' ? am5.color('#fff') : am5.color('#231F20'),
        });


        yAxis.data.setAll(chartData);

        // Calculate dynamic axis min/max values with padding
        let axisMinValue = -10; // Default min value if no data or single point
        let axisMaxValue = 10;  // Default max value if no data or single point

        if (chartData && chartData.length > 0) {
            const values = chartData
                .map(item => item['change'])
                .filter(value => typeof value === 'number' && !isNaN(value));

            if (values.length > 0) {
                const dataMin = Math.min(...values);
                const dataMax = Math.max(...values);
                
                const range = dataMax - dataMin;
                let padding;

                if (range === 0) {
                    // If all values are the same, use 5% of the absolute value as padding,
                    // or a default padding if the value is 0.
                    padding = dataMin === 0 ? 1 : Math.abs(dataMin * 0.05);
                } else {
                    padding = range * 0.09; 
                }
                
                axisMinValue = dataMin - padding;
                axisMaxValue = dataMax + padding;

                // Ensure min and max are not the same if padding was 0
                if (axisMinValue === axisMaxValue) {
                    axisMinValue -= 1;
                    axisMaxValue += 1;
                }
            }
        }

        // Create X-Axis with dynamic min/max values
        var xAxis = chart.xAxes.push(
            am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererX.new(root, {
                    strokeOpacity: 0.1,
                    minGridDistance: 30,
                }),
                min: axisMinValue,
                max: axisMaxValue
            })
        );

        xAxis.get("renderer").grid.template.setAll({
            strokeOpacity: 1,
            stroke: theme == 'dark' ? am5.color('#626262') : am5.color('#E4E4E4'),
            strokeDasharray: [4, 4]
        });


        xAxis.get("renderer").labels.template.setAll({
            oversizedBehavior: "wrap",
            maxWidth: 150,
            textAlign: "center",
            fontSize: 12,
            fontFamily: 'Roboto-Medium',
            fill: theme == 'dark' ? am5.color('#fff') : am5.color('#231F20'),
        });


        // Create series 2

        var tooltipHTML = createTooltipHTML(theme);

        let tooltipLineSeries = am5.Tooltip.new(root, {
            keepTargetHover: true,
            // labelText: "[bold]{Date.formatDate('dd/MM/yyyy')}[/]\nFiyat: {valueY}\nHacim: {Volume}",
            getFillFromSprite: true,
            getStrokeFromSprite: true,
            autoTextColor: true,
            getLabelFillFromSprite: true,
            fill: am5.color("#333"),
        });

        tooltipLineSeries.get("background").setAll({
            fill: am5.color("#333"),
            fillOpacity: 0,
            strokeOpacity: 0,
            getStrokeFromSprite: true,
        });
        tooltipLineSeries.label.set("fill", am5.color("#231f20")); // Beyaz
        let series = chart.series.push(
            am5xy.ColumnSeries.new(root, {
                xAxis: xAxis,
                yAxis: yAxis,
                valueXField: 'change',
                categoryYField: "Name",

                sequencedInterpolation: true,
                clustered: true,
                stroke: theme === 'dark' ? am5.color('#35353e') : am5.color('#fff'),
                fill: theme === 'dark' ? am5.color('#35353e') : am5.color('#fff'),
                fillOpacity: 1,
                strokeWidth: 1,
                tooltip: tooltipLineSeries,
                tooltipHTML: tooltipHTML,

                // tooltip: am5.Tooltip.new(root, {
                //     pointerOrientation: 'right',
                //     labelText: "{Name}: [/]\n %{valueX.formatNumber('###.##')}",
                //     fill: theme == 'dark' ? am5.color('#fff') : am5.color('#231F20'),
                //     fillOpacity: 0.8,
                //     autoTextColor: false,
                // })
            })
        );

        series.columns.template.setAll({
            fillOpacity: 1,
            strokeWidth: 0,
            cornerRadiusTR: 5,
            cornerRadiusBR: 5,
        });

        series.columns.template.adapters.add("fill", function (fill, target) {

            var dataItem = target.dataItem;
            if (dataItem.get("valueX") < 0) {
                target.set("tooltipY", am5.p100);
                series.columns.template.set("fillGradient", am5.LinearGradient.new(root, {
                    stops: [{
                        color: am5.color('#CB2D3E')
                    }, {
                        color: am5.color('#EF473A')
                    }],
                    rotation: 45
                }));
            }
            else {
                target.set("tooltipY", am5.p0);
                series.columns.template.set("fillGradient", am5.LinearGradient.new(root, {
                    stops: [{
                        color: am5.color('#418079')
                    }, {
                        color: am5.color('#2FBC99')
                    }],
                    rotation: 45
                }));
            }
        })
        series.data.setAll(chartData);



        // Replace the current bullets code with this modified version
        series.bullets.push(function (root, series, dataItem) {
            const value = dataItem.get("valueX");
            let labelCenterX;
            let labelDx;
            const padding = 8; // Increased padding to accommodate background
            const labelBackgroundColor = theme === 'dark' ? am5.color(0x000000) : am5.color(0xffffff);
            const labelTextColor = theme === 'dark' ? am5.color(0xffffff) : am5.color(0x000000);

            if (value < 0) {
                labelCenterX = am5.p0;   // Align left edge of label to anchor point
                labelDx = padding;       // Shift label to the right
            } else {
                labelCenterX = am5.p100; // Align right edge of label to anchor point
                labelDx = -padding;     // Shift label to the left
            }

            return am5.Bullet.new(root, {
                locationY: 0.5, // Vertically centered on the bar
                locationX: 1,   // Anchored at the tip of the bar
                sprite: am5.Label.new(root, {
                    text: "{valueX.formatNumber('#.##')}%", // Format text as percentage
                    populateText: true,
                    centerY: am5.p50, // Vertically center the text in the label
                    centerX: labelCenterX,
                    dx: labelDx,
                    fill: labelTextColor,
                    fontFamily: 'Roboto-Medium',
                    fontSize: 13, // Slightly increased font size
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5,
                    background: am5.RoundedRectangle.new(root, {
                        fill: labelBackgroundColor,
                        fillOpacity: 0.2, // Further reduced background opacity
                        cornerRadius: 3,
                    })
                })
            });
        });

        // Add legend
        // let legend = chart.children.push(am5.Legend.new(root, {}));
        // legend.data.setAll(chart.series.values);
        // Add cursor
        chart.set("cursor", am5xy.XYCursor.new(root, {}));

        return () => {
            root.dispose();
        };
    }, [chartData, theme, chartDomId, props.domId]);
    const createTooltipHTML = () => {
        // Temaya göre renkleri ayarlayın
        const priceColor = theme === 'dark' ? '#2FBC99' : '#2FBC99';
        const volumeColor = theme === 'dark' ? '#67b7dc' : '#67b7dc';
        const backgroundColor = theme === 'dark' ? '#121212' : '#FFFFFF';
        const textColor = theme === 'dark' ? '#fff' : '#231f20';
        const textGray = theme === 'dark' ? '#FFFFFF' : '#757575';

        return `
        <div style="font-size:16px; font-family:Roboto-Medium; padding: 5px; background-color: ${backgroundColor}; color:  ${textColor}; border-radius: 5px; min-width: auto; border:.5px solid #b5b5b5">
           
            <div style="font-size:16px; font-family:Roboto-Medium;"> 
           
            {Name}:  %{valueX.formatNumber('###.##')} 
         
            </div>

        </div>`;
    }

    return (
        <div className='price-performance-chart'>
            <div id={props.domId} style={{ width: "100%", height: "220px" }}></div>
        </div>
    );

}

export default PricePerformance;